/**
 * Definitions for BE managed types are defined here.
 *
 * Add more when new APIs are implemented. Also modify existing models when BE updates their schema.
 */
export let ConvertTermID;

(function (ConvertTermID) {
  ConvertTermID[ConvertTermID["SHORT_TERM"] = 1] = "SHORT_TERM";
  ConvertTermID[ConvertTermID["MID_TERM"] = 2] = "MID_TERM";
  ConvertTermID[ConvertTermID["LONG_TERM"] = 3] = "LONG_TERM";
})(ConvertTermID || (ConvertTermID = {}));

export let ConvertHistoryStatus;

(function (ConvertHistoryStatus) {
  ConvertHistoryStatus[ConvertHistoryStatus["PROCESSING"] = 1] = "PROCESSING";
  ConvertHistoryStatus[ConvertHistoryStatus["COMPLETED"] = 2] = "COMPLETED";
  ConvertHistoryStatus[ConvertHistoryStatus["CANCELLED"] = 3] = "CANCELLED";
})(ConvertHistoryStatus || (ConvertHistoryStatus = {}));